import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const CustomerOutstandingList = lazy(() => import('./pages/CustomerOutstandingList'));
const CustomerOutstandingDetail = lazy(() => import('./pages/CustomerOutstandingDetail'));
const MakePaymentPage = lazy(() => import('./pages/MakePaymentPage'));
const PaymentDetailPage = lazy(() => import('./pages/PaymentDetailPage'));
const CustomerReportPage = lazy(() => import('./pages/CustomerReportPage'));

const creditPaymentRoutes: RouteObject[] = [
  {
    index: true,
    element: <CustomerOutstandingList />,
  },
  {
    path: 'customers/:customerId',
    element: <CustomerOutstandingDetail />,
  },
  {
    path: 'customers/:customerId/pay',
    element: <MakePaymentPage />,
  },
  {
    path: 'customers/:customerId/report',
    element: <CustomerReportPage />,
  },
  {
    path: 'payments/:paymentId',
    element: <PaymentDetailPage />,
  },
];

export default creditPaymentRoutes;
